import { Component, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { Input } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { HelperService } from '../../../../services/helper/helper.service';
import { ControlBaseComponent } from '../control/control.component';

@Component({
  selector: 'app-control-text-input',
  styleUrls: ['./control-text-input.component.scss'],
  templateUrl: './control-text-input.component.html',
})
export class ControlTextInputComponent extends ControlBaseComponent implements OnChanges {

  @Input() isDisabled: boolean = false;
  @Input() isRequired: boolean;
  @Input() minLength: number = null;
  @Input() maxLength: number = null;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() model: any;
  @Input() bindValue: string;
  @Input() cssClass: string;
  @Input() controlName: any;
  @Input() inlineControl = false;
  @Output() ngModelChange = new EventEmitter();
  @Output() ngValidationError = new EventEmitter();

  constructor(public helperService: HelperService,
    private changeDetection: ChangeDetectorRef) {
    super(helperService);
  }

  private SearchTimeout;

  private searchDelay = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.maxLength) {
      this.maxLength = 1024;
    }
  }

  onKeyUp() {
    if (this.SearchTimeout) {
      clearTimeout(this.SearchTimeout);
      this.searchDelay = true;
    }
    if (this.searchDelay) {
      this.searchDelay = false;
      this.SearchTimeout = setTimeout(() => {
        this.ModelChange();
      }, 5000);
    }
    return;
  }


  ModelChange() {
    if (this.minLength
      && (this.model[this.bindValue]
        && this.model[this.bindValue].length < this.minLength
        && this.model[this.bindValue].length > 0
      )
    ) {
      this.isValidationError = true;
    } else {
      this.isValidationError = false;
    }

    if (this.ngModelChange) {
      this.ngModelChange.emit();
    }

    if (this.ngValidationError) {
      this.ngValidationError.emit(this.isValidationError);
    }
  }

  onClear() {
    this.model[this.bindValue] = undefined;
    this.changeDetection.detectChanges();
    this.ModelChange();
  }
}
